import { useEffect, useMemo } from 'react';
import { useLazyQuery } from '@apollo/client/react';

import { APPLICATION } from 'queries/applications';

const useApplicationQuery = (applicationId, options = {}) => {
  const [getApplication, applicationQuery] = useLazyQuery(APPLICATION, {
    ...options,
  });

  const [application, applicant, bureauReports, documents, sponsorBank] =
    useMemo(() => {
      let application = {};
      let applicant = {};
      let bureauReports = [];
      let documents = {};
      let sponsorBank = '';
      if (applicationQuery.data) {
        application = applicationQuery.data.applicationV2;
        applicant = application.submission.applicants[0] || {};
        bureauReports = application.bureauReports || [];
        documents = application.documents || {};
        sponsorBank = application.sponsorBank;
      }
      return [application, applicant, bureauReports, documents, sponsorBank];
    }, [applicationQuery.data]);

  useEffect(() => {
    if (applicationId) {
      getApplication({ variables: { applicationId } });
    }
  }, [applicationId]);

  return {
    application,
    applicationQuery,
    applicant,
    bureauReports,
    documents,
    sponsorBank,
  };
};

export default useApplicationQuery;
